// Address of the converter that runs the server tools (Phase 5): Ghostscript,
// qpdf and LibreOffice. Baked in at build time. Empty → server tools are left
// out of the lists and their pages say they aren't available here.
//   local Docker / npm run converter: http://localhost:8081
//   live: the Lambda function URL (npm run deploy:aws reads it from AWS)
export const converterUrl = (
  process.env.NEXT_PUBLIC_CONVERTER_URL ?? ""
).replace(/\/+$/, "");

/** Where to send someone with a locked PDF (Unlock PDF needs the converter).
 *  Lives here, not in lib/pdf/load.ts, so page code doesn't pull in pdf-lib. */
export const REMOVE_PASSWORD = converterUrl
  ? "Please remove the password first — Unlock PDF can do that."
  : "Please remove the password first.";
